import type { CandidateState } from "../../api/client";

export function SubmittedStep({ state }: { state: CandidateState }) {
  return (
    <section>
      <h1>Application submitted</h1>
      <p>
        Thank you. Your answers are with the Tekdi team
        {state.submitted_at && ` (submitted ${new Date(state.submitted_at).toLocaleString()})`}. A
        person reviews every application; we'll contact you at the email on your GitHub account.
      </p>
      <p className="muted">There's nothing more to do here. You can close this page.</p>
    </section>
  );
}
